// Opportunity types that cannot stand alone: a new opportunity of one of these
// types must name its parent opportunity. Shared by the New Opportunity form on
// the Opportunity Tracker and by POST /api/sows, so the two cannot disagree.
export const TYPES_REQUIRING_PARENT = ['SFA'];

export function typeRequiresParent(type) {
  const t = String(type ?? '').trim().toLowerCase();
  return !!t && TYPES_REQUIRING_PARENT.some(x => x.toLowerCase() === t);
}
